import getSignedURL from './getSignedURL';
import { generateFile } from './generateFile';
import submitImage from './submitImage';

const submitImageToStorage = async (folderName, file, fileName) => {
    const awsFolder = folderName + '/' + fileName + '.png';
    const signedURLObject = await getSignedURL(awsFolder);

    const blobFile = await generateFile(file, signedURLObject.fields, fileName);
    const submitResponse = await submitImage(signedURLObject.url, blobFile);
    if (submitResponse === 204) {
        return `${signedURLObject.url}${awsFolder}`;
    }
};

export default submitImageToStorage;
